import React, { Component, Fragment } from 'react'
import Breadcrumb from "../../common/breadcrumb"
import Datatable from '../../common/datatable'
import {Link} from 'react-router-dom'
import Modal from 'react-responsive-modal';
import { getObjects, deleteObject } from "../../api";

export class MediaList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            loading: true, // set to false once loading is completed
            editingRow: {},
            actionMode: '',
            data: {},
            tagString: ""
        };
    }

    onOpenModal = () => {
        this.setState({ editingRow: {}, actionMode: 'new', open: true });
    };

    onCloseModal = (mode) => {
        this.setState({ open: false });
        if(mode === true)
        {
            if (document.getElementById("newMedia").elements['actionMode'].value === 'delete') {
                this.onDeleteMedia(  document.getElementById("newMedia").elements['itemId'].value);
            }
        } else {
            console.log('cancel');
        }
    };

    onTagsChange = (e) => {
        const tags = e.target.value.toUpperCase().split(",").map(x=>x.trim()).join(", ");
        this.setState({tagString: tags})
    }
    onItemEdit = (row) => {
        this.props.history.push(`/admin/media/edit?pid=${row._id}`)
    };

    onFilterClick = () => {
        this.loadMedias() ;
    }

    onItemDelete = (row) => {
        this.setState({editingRow: row, actionMode: 'delete', open: true });        
    };

    onDeleteMedia = (id) => {
        deleteObject('media', id).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.loadMedias(null);
            }
        });
    };

    loadMedias = () => {
        const {tagString} = this.state;

        this.setState({  loading: true});
        const filter = tagString.length ? {tags: { $all: tagString.split(",").map(x=>x.trim()).filter(Boolean)}} : null;
        getObjects('media', null, filter).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.setState({ data: d2, loading: false});
            }
        });
    };

    componentDidMount(){
        this.loadMedias();
    }

    render() {
        const { open } = this.state;

        if (this.state.loading) { return null; }
        else {
            setTimeout(function() {
                document.querySelector(".loader-wrapper").style = "display: none";
            }, 100);       
        return (
            <Fragment>
                <Breadcrumb title="Media List" />

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <label>Tags</label>
                                    <input className="w-100 p-2 m-2" type='text' id='tagFilter' onChange={this.onTagsChange} value={this.state.tagString}/>&nbsp;

                                    <div className="btn-popup pull-right">
                                        <button type="button" className="btn btn-primary" onClick={this.onFilterClick}>Apply Filter</button>&nbsp; 
                                        <Link to="/admin/media/create">
                                            <button type="button" className="btn btn-primary">Add Media</button>  
                                        </Link>                                                                                                                     
                                    </div>
                                    <Modal open={open} onClose={this.onCloseModal} >
                                        <div className="modal-header">
                                            <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                                            {this.state.actionMode==='delete'?'Delete ':this.state.actionMode==='update'?'Update ':'Add '}
                                            Media File</h5>
                                        </div>
                                        <div className="modal-body">
                                            <form id="newMedia">
                                                <input type="hidden" id="itemId" value={this.state.editingRow._id?this.state.editingRow._id:''} />
                                                <input type="hidden" id="actionMode" value={this.state.actionMode} />
                                                <div className="form-group">
                                                    <label htmlFor="recipient-name" className="col-form-label" >Media Name :</label>
                                                    <input id="mediaTitle" defaultValue={this.state.editingRow.title?this.state.editingRow.title:''} type="text" className="form-control" />
                                                </div>
                                            </form>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-primary" onClick={() => this.onCloseModal(true)}>{this.state.actionMode==='delete'?'Delete':'Save'}</button>
                                            <button type="button" className="btn btn-secondary" onClick={() => this.onCloseModal(false)}>Close</button>
                                        </div>
                                    </Modal>    
                                    <div className="clearfix"></div>
                                    <div id="batchDelete" className="category-table media-table coupon-list-delete">
                                        <Datatable
                                            multiSelectOption={false}
                                            myData={this.state.data}
                                            columns={['baseUrl', 'filename', 'title', 'wpId', 'contentType']}
                                            imageUrlField='baseUrl'
                                            showCopy={'baseUrl'}
                                            pageSize={10}
                                            pagination={true}
                                            onItemDelete={this.onItemDelete}
                                            onItemEdit={this.onItemEdit}
                                            class="-striped -highlight"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}
}
export default MediaList
